
/**
 * 통화 코드
 */
export type CoursePriceCurrency = typeof CoursePriceCurrency[keyof typeof CoursePriceCurrency];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CoursePriceCurrency = {
  KRW: 'KRW',
  USD: 'USD',
  EUR: 'EUR',
} as const;
